import { Component } from '@angular/core';

@Component({
  selector: 'access-denied-page',
  templateUrl: './access-denied-page.component.html'
})
export class AccessDeniedPageComponent {
}
